import { ProfileViewSettings } from './profile-view-settings';

/**
 * Représente les paramètres de profil.
 */
export class ProfileSettings {
    /**
     * Identifiant de la vue selectionnée par défaut.
     */
    public defaultViewId?: number;
    /**
     * Indique si les filtres sont sauvegardés et restaurés automatiquement (obsolète).
     */
    public autoFiltersSaveAndRestore: boolean;
    /**
     * Indique si l'écran de suivi des dossiers est visible.
     */
    public showFolderFollow: boolean;
    /**
     * Paramétrage des vues.
     */
    public viewSettings: Map<number, ProfileViewSettings> = new Map<number, ProfileViewSettings>();

    /**
     * Retourne une instance de ProfileSettings à partir d'une instance de ProfileSettings.
     * @param other : Instance de ProfileSettings.
     * @returns : Instance de ProfileSettings.
     */
    public static from(other: ProfileSettings) {
        if (!!other) {
            const instance = new ProfileSettings();

            instance.autoFiltersSaveAndRestore = other.autoFiltersSaveAndRestore;
            instance.defaultViewId = other.defaultViewId;
            instance.showFolderFollow = other.showFolderFollow;
            instance.viewSettings;

            for (let key of Object.keys(other.viewSettings)) {
                const profileViewSettings = ProfileViewSettings.from(other.viewSettings[key]);
                instance.viewSettings.set(Number.parseInt(key), profileViewSettings);
            }

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne la représentation JSON d'une instance de ProfileSettings.
     * remarks : La classe ProfileSettings contenant une propriété de type Map, il est neccessaire de la convertir en tableau d'object pour qu'elle ne soit pas perdu au moment de la serialisation.
     * @param original : Instance de ProfileSettings.
     * @returns : La représentation JSON de l'instance de ProfileSettings.
     */
    public static toJSON(original: ProfileSettings) {
        if (!!original) {
            const json = JSON.stringify(original);
            const instance = JSON.parse(json);

            instance.viewSettings = new Object();

            original.viewSettings.forEach((value, key) => {
                const profileViewSettings = ProfileViewSettings.from(original.viewSettings.get(key));
                instance.viewSettings[key] = profileViewSettings;
            });

            return JSON.stringify(instance);
        } else {
            return null;
        }
    }
}
